<agpr-take-over-panel
    [header]="title"
    [overlayContainer]="overlayContainer"
    [animationTrigger]="animationTrigger"
    [hideSlideOverlay]="hideSlideOverlay"
    [showFooter]="false"
    (visibleChange)="closeDialog($event)"
    (finishedOpen)="panelOpened()"
    [responsiveWidth]="true"
    [minPanelWidth]="minPanelWidth"
    [maxPanelWidth]="maxPanelWidth"
>
    <div class="agpr-headerEditor-bodyWrapper">
        <div class="agpr-headerEditor-container">
            <!-- Left Side -->
            <div
                [agprLoading]="!doneSettingBodyText"
                class="agpr-headerEditor-fields"
            >
                <div class="agpr-required-label">
                    <span class="agpr-requiredAsterix"> * </span>
                    {{ 'Amplify.wire.headerEditor.required' | localize }}
                </div>

                <!-- Headline -->
                <div class="agpr-headerEditor-fields-labels">
                    <label>{{ 'Amplify.wire.headerEditor.headline' | localize }}</label>
                    <span class="agpr-requiredAsterix"> *</span>
                    <span
                        role="img"
                        class="fa-regular fa-circle-info agpr-headerEditor-infoCircle"
                        agprTooltip="Amplify.wire.headerEditor.headline.tooltip"
                    ></span>
                </div>
                <div
                    [class.agpr-headerEditor-inputs]="openAiPermission"
                >
                    <agpr-text-input #headlineInput
                        placeholder = "Amplify.wire.headerEditor.headline.placeholder"
                        ariaLabel="Amplify.wire.headerEditor.headline.placeholder"
                        [(ngModel)]="headline"
                        [id]="'headerEditor.headlineInput'"
                        [initialFocus]="true"
                        (keyup)="headlineKeyUp($event)"
                        (focus)="showInfo(infoTypes.headline)"
                        (blur)="validateHeadline($event)"
                        [maxLength]="200"
                        [icon]="headline && headline.length > 0 ? (assessmentMessages.headline.length > 0 ? 'fa-regular fa-duotone fa-circle-exclamation' : 'fa-regular fa-duotone fa-circle-check') : null"
                        [iconPopoverTemplate]="headline && headline.length > 0 ? (assessmentMessages.headline.length > 0 ? headlinePopover : null) : null"
                        [iconPopoverStyleClass]="'agpr-headerEditor-hintsPopover'"
                        [iconPopoverText]="assessmentMessages.headline.toString()"
                    >
                    </agpr-text-input>
                </div>
                <div
                    *ngIf="openAiPermission"
                    class="agpr-headerEditor-aiButtons"
                >
                    <agpr-button
                        [id]="'agpr_headerEditor_generateHeadline'"
                        class="agpr-headerEditor-plainButton"
                        [style]="buttonTypes.icon"
                        [icon]="'fa-kit-duotone fa-agpr-ai'"
                        [tooltip]="noBodyText ? 'Amplify.wire.headerEditor.noBodyTextHeadline' : 'Amplify.wire.headerEditor.generateHeadline'"
                        tooltipPosition="top"
                        ariaLabel="Amplify.wire.headerEditor.generateHeadline"
                        [disabled]="headlinePromptsLoading || subHeadlinePromptsLoading || noBodyText"
                        (click)="generateHeadline($event)"
                    ></agpr-button>
                </div>
                <div
                    [@panelState]="(headlinePrompts?.length || headlinePromptsLoading) && showHeadlinePrompts ? 'visible' : 'hidden'"
                    class="agpr-headerEditor-suggestions-container"
                    [class.agpr-headerEditor-suggestions-container-loading]="headlinePromptsLoading"
                    [class.agpr-headerEditor-suggestions-container-finished]="!headlinePromptsLoading"
                    (focusout)="dismissPromptsByFocus($event)"
                >
                    <div
                        *ngIf="showHeadlinePrompts"
                        class="agpr-headerEditor-suggestions-content"
                    >
                        <ul [attr.aria-label]="'Amplify.wire.headerEditor.headline.optionsList' | localize">
                            <li
                                *ngFor="let suggestion of headlinePrompts; let i = index"
                                tabindex="0"
                                class="agpr-headerEditor-suggestions-item"
                                [class.agpr-headerEditor-suggestions-item-selected]="headlineSelected === i"
                                (keyup.enter)="setHeadline(suggestion)"
                                (click)="setHeadline(suggestion)"
                            >
                                <span class="agpr-headerEditor-suggestions-item-text">{{suggestion | localize}}</span>
                            </li>
                            <!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
                            <li
                                *ngIf="headlinePromptsLoading"
                                id="agpr_headerEditor_headlineLoading"
                                class="agpr-headerEditor-suggestions-item agpr-headerEditor-suggestions-item-loading"
                                [agprLoading]="true"
                                [agprInlineLoadingIndicator]="true"
                                [loadingSmallIndicator]="true"
                                [attr.aria-label]="'Headline Loading'"
                                (click)="doNotCloseHeadline($event)"
                            >
                            </li>
                            <!-- eslint-enable @angular-eslint/template/interactive-supports-focus -->
                        </ul>
                    </div>
                </div>
                <ng-template #headlinePopover>
                    <div class="agpr-headerEditor-fields-assessment-popover">
                        <span
                            class="agpr-headerEditor-fields-assessment-popover-icon agpr-message-icon fa-duotone fa-regular fa-circle-info"
                            aria-hidden="true"
                        ></span>
                        <div class="agpr-headerEditor-fields-assessment-popover-content">
                            <p
                                *ngFor="let message of assessmentMessages.headline"
                                class="agpr-headerEditor-fields-assessment-popover-content-message"
                            >
                                {{ message }}
                            </p>
                        </div>
                    </div>
                </ng-template>
                <span #headlineLiveRegion class="sr-only" role="region" aria-live="polite"></span>
                <agpr-form-message *ngIf="headlineError">
                    {{ 'Amplify.wire.header.errors.hasNoHeadline' | localize }}
                </agpr-form-message>
                <agpr-form-message *ngIf="headlineByteLength > 200">
                    <p>{{ 'Amplify.wire.error.headlineExceedsByteLengthLimit.full' | localize: { byteLength: headlineByteLength } }}</p>
                </agpr-form-message>


                <!-- Sub Headline -->
                <div class="agpr-headerEditor-fields-labels">
                    <label>{{ 'Amplify.wire.headerEditor.subHeadline' | localize }}</label>
                    <span
                        role="img"
                        class="fa-regular fa-circle-info agpr-headerEditor-infoCircle"
                        agprTooltip="Amplify.wire.headerEditor.subHeadline.tooltip"
                    ></span>
                </div>
                <div
                    [class.agpr-headerEditor-inputs]="openAiPermission"
                >
                    <agpr-text-input #subHeadlineInput
                        ariaLabel="Amplify.wire.headerEditor.subHeadline.placeholder"
                        placeholder = "Amplify.wire.headerEditor.subHeadline.placeholder"
                        [(ngModel)]="subHeadline"
                        [id]="'headerEditor.subHeadlineInput'"
                        (keyup)="subHeadlineKeyUp($event)"
                        (focus)="showInfo(infoTypes.subHeadline)"
                        (blur)="validateSubHeadline($event)"
                        [maxLength]="200"
                        [icon]="(assessmentMessages && assessmentMessages.subHeadline.length > 0) ? 'fa-regular fa-duotone fa-circle-exclamation fa-duotone' : 'fa-regular fa-duotone fa-circle-check'"
                        [iconPopoverTemplate]="(assessmentMessages && assessmentMessages.subHeadline.length > 0) ? subHeadlinePopover : null"
                        [iconPopoverStyleClass]="'agpr-headerEditor-hintsPopover'"
                        [iconPopoverText]="assessmentMessages.subHeadline.toString()"
                    >
                    </agpr-text-input>
                </div>
                <div
                    *ngIf="openAiPermission"
                    class="agpr-headerEditor-aiButtons"
                >
                    <agpr-button
                        [id]="'agpr_headerEditor_generateSubHeadline'"
                        class="agpr-headerEditor-plainButton"
                        [style]="buttonTypes.icon"
                        [icon]="'fa-kit-duotone fa-agpr-ai'"
                        [tooltip]="noBodyText ? 'Amplify.wire.headerEditor.noBodyTextSubHeadline' : 'Amplify.wire.headerEditor.generateSubHeadline'"
                        tooltipPosition="top"
                        ariaLabel="Amplify.wire.headerEditor.generateSubHeadline"
                        [disabled]="headlinePromptsLoading || subHeadlinePromptsLoading || noBodyText"
                        (click)="generateSubHeadline($event)"
                    ></agpr-button>
                </div>
                <div
                    [@panelState]="(subHeadlinePrompts?.length || subHeadlinePromptsLoading) && showSubHeadlinePrompts ? 'visible' : 'hidden'"
                    [class.agpr-headerEditor-suggestions-container-loading]="subHeadlinePromptsLoading"
                    [class.agpr-headerEditor-suggestions-container-finished]="!subHeadlinePromptsLoading"
                    class="agpr-headerEditor-suggestions-container"
                    (focusout)="dismissPromptsByFocus($event)"
                >
                    <div
                        *ngIf="showSubHeadlinePrompts"
                        class="agpr-headerEditor-suggestions-content"
                    >
                        <ul [attr.aria-label]="'Amplify.wire.headerEditor.subHeadline.optionsList' | localize">
                            <li
                                *ngFor="let suggestion of subHeadlinePrompts; let i = index"
                                class="agpr-headerEditor-suggestions-item"
                                tabindex="0"
                                [class.agpr-headerEditor-suggestions-item-selected]="subHeadlineSelected === i"
                                (keyup.enter)="setSubHeadline(suggestion)"
                                (click)="setSubHeadline(suggestion)"
                            >
                            <span class="agpr-headerEditor-suggestions-item-text">{{suggestion | localize}}</span>
                            </li>
                            <!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
                            <li
                                *ngIf="subHeadlinePromptsLoading"
                                id="agpr_headerEditor_subHeadlineLoading"
                                class="agpr-headerEditor-suggestions-item agpr-headerEditor-suggestions-item-loading"
                                [agprLoading]="true"
                                [agprInlineLoadingIndicator]="true"
                                [loadingSmallIndicator]="true"
                                (click)="doNotCloseSubHeadline($event)"
                            >
                            </li>
                            <!-- eslint-enable @angular-eslint/template/interactive-supports-focus -->
                        </ul>
                    </div>
                </div>
                <ng-template #subHeadlinePopover>
                    <div class="agpr-headerEditor-fields-assessment-popover">
                        <span
                            class="agpr-headerEditor-fields-assessment-popover-icon agpr-message-icon fa-regular fa-circle-info"
                            aria-hidden="true"
                        ></span>
                        <div class="agpr-headerEditor-fields-assessment-popover-content">
                            <p
                                *ngFor="let message of assessmentMessages.subHeadline"
                                class="agpr-headerEditor-fields-assessment-popover-content-message"
                            >
                                {{ message }}
                            </p>
                        </div>
                    </div>
                </ng-template>
                <span #subHeadlineLiveRegion class="sr-only" role="region" aria-live="polite"></span>


                <!-- Company Name -->
                <div class="agpr-headerEditor-fields-labels">
                    <label>{{ 'Amplify.wire.headerEditor.companyName' | localize }}</label>
                    <span class="agpr-requiredAsterix"> *</span>
                    <span
                        role="img"
                        class="fa-regular fa-circle-info agpr-headerEditor-infoCircle"
                        agprTooltip="Amplify.wire.headerEditor.companyName.tooltip"
                    ></span>
                </div>
                <agpr-text-input #companyNameInput
                    ariaLabel="Amplify.wire.headerEditor.companyName.placeholder"
                    placeholder = "Amplify.wire.headerEditor.companyName.placeholder"
                    [(ngModel)]="companyName"
                    [id]="'headerEditor.companyNameInput'"
                    (keyup)="companyNameKeyUp($event)"
                    (focus)="showInfo(infoTypes.companyName)"
                    (blur)="validateCompanyName()"
                    [maxLength]="256"
                    [icon]="emailIcon"
                    [iconPopoverTemplate]="emailIcon === 'fa-regular fa-duotone fa-circle-exclamation' ? companyNamePopover : null"
                    [iconPopoverStyleClass]="'agpr-headerEditor-hintsPopover'"
                    [iconPopoverText]="assessmentMessages.companyName.toString()"
                >
                </agpr-text-input>
                <ng-template #companyNamePopover>
                    <div class="agpr-headerEditor-fields-assessment-popover">
                        <span
                            class="agpr-headerEditor-fields-assessment-popover-icon agpr-message-icon fa-regular fa-circle-info"
                            aria-hidden="true"
                        ></span>
                        <div class="agpr-headerEditor-fields-assessment-popover-content">
                            <p
                                *ngFor="let message of assessmentMessages.companyName"
                                class="agpr-headerEditor-fields-assessment-popover-content-message"
                            >
                                {{ message }}
                            </p>
                        </div>
                    </div>
                </ng-template>
                <span #companyNameLiveRegion class="sr-only" role="region" aria-live="polite"></span>
                <agpr-form-message *ngIf="emailIcon === 'fa-regular fa-duotone fa-circle-xmark'">
                  {{ 'invalidEmailFormat' | localize }}
                </agpr-form-message>
                <agpr-form-message *ngIf="companyNameError">
                    {{ 'Amplify.wire.header.errors.hasNoCompanyName' | localize }}
                </agpr-form-message>

                <!-- Dateline -->
                <div class="agpr-headerEditor-fields-labels">
                    <label>{{ 'Amplify.wire.headerEditor.dateline' | localize }}</label>
                    <span class="agpr-requiredAsterix"> *</span>
                    <span
                        role="img"
                        class="fa-regular fa-circle-info agpr-headerEditor-infoCircle"
                        agprTooltip="Amplify.wire.headerEditor.dateline.tooltip"
                    ></span>
                </div>
                <agpr-text-input #datelineInput
                    ariaLabel="Amplify.wire.headerEditor.dateline.placeholder"
                    placeholder = "Amplify.wire.headerEditor.dateline.placeholder"
                    [(ngModel)]="dateline"
                    [id]="'headerEditor.datelineInput'"
                    (keyup)="datelineKeyUp($event)"
                    (blur)="isDatelineFocused = false"
                    (focus)="showInfo(infoTypes.dateline)"
                    [maxLength]="64"
                    [icon]="dateline && dateline.length > 0 ? (assessmentMessages.dateline.length > 0 ? 'fa-regular fa-duotone fa-circle-exclamation' : 'fa-regular fa-duotone fa-circle-check') : null"
                    [iconPopoverTemplate]="dateline && dateline.length > 0 ? (assessmentMessages.dateline.length > 0 ? datelinePopover : null) : null"
                    [iconPopoverStyleClass]="'agpr-headerEditor-hintsPopover'"
                    [iconPopoverText]="assessmentMessages.dateline.toString()"
                >
                </agpr-text-input>
                <ng-template #datelinePopover>
                    <div class="agpr-headerEditor-fields-assessment-popover">
                        <span
                            class="agpr-headerEditor-fields-assessment-popover-icon agpr-message-icon fa-regular fa-circle-info"
                            aria-hidden="true"
                        ></span>
                        <div class="agpr-headerEditor-fields-assessment-popover-content">
                            <p
                                *ngFor="let message of assessmentMessages.dateline"
                                class="agpr-headerEditor-fields-assessment-popover-content-message"
                            >
                                {{ message }}
                            </p>
                        </div>
                    </div>
                </ng-template>
                <span #datelineLiveRegion class="sr-only" role="region" aria-live="polite"></span>
                <agpr-form-message *ngIf="datelineError">
                    {{ 'Amplify.wire.header.errors.hasNoFrom' | localize }}
                </agpr-form-message>
            </div>

            <!-- Right Side -->
            <div class="agpr-headerEditor-infoPanel">
                <div class="agpr-headerEditor-infoPanel-header">
                    <span class="agpr-headerEditor-infoPanel-header-icon agpr-i-light-bulb" aria-hidden="true"></span>
                    <div class="agpr-headerEditor-infoPanel-header-content">
                        <span class="agpr-headerEditor-infoPanel-header-content-quickTips">{{ 'Amplify.wire.headerEditor.quickTips' | localize }} - </span>
                        <span
                            *ngIf="!infoContent.label"
                            class="agpr-headerEditor-infoPanel-header-content-field"
                        >
                            {{ 'Amplify.wire.headerEditor.defaultInfoHeader' | localize }}
                        </span>
                        <span
                            *ngIf="infoContent.label"
                            class="agpr-headerEditor-infoPanel-header-content-field"
                        >
                            {{ infoContent.label | localize }}
                        </span>
                    </div>
                </div>
                <div
                    *ngIf="!infoContent.label"
                    class="agpr-headerEditor-infoPanel-content-placeholder"
                >
                    <p>{{ 'Amplify.wire.headerEditor.defaultInfoContent' | localize }}</p>
                </div>
                <ul class="agpr-headerEditor-infoPanel-content-list">
                    <li *ngFor="let hint of infoContent.hints">{{ hint | localize }}
                        <div
                            *ngIf="hint === 'Amplify.wire.headerEditor.hints.dateline.4'"
                            (clickOutside)="validateDateline()"
                            [exclude]="'.agpr-headerEditor-dateline'"
                        >
                            <a class="agpr-headerEditor-infoPanel-link" target="_blank" href="https://writingexplained.org/ap-style/ap-style-datelines">{{'Amplify.wire.headerEditor.hints.dateline.4.link' | localize}}</a>
                        </div>
                        <div
                            *ngIf="hint === 'Amplify.wire.headerEditor.hints.dateline.3'"
                            class="agpr-headerEditor-infoPanel-boldText"
                        >
                            {{'Amplify.wire.headerEditor.hints.dateline.3.boldText' | localize}}
                        </div>
                    </li>
                </ul>
                <div
                    *ngIf="openAiPermission && aiQuickTipInfo"
                    class="agpr-headerEditor-aiQuickTip"
                >
                    <div class="agpr-headerEditor-aiQuickTip-iconContainer">
                        <span class="agpr-headerEditor-aiQuickTip-icon fa-light fa-brain-circuit"></span>
                    </div>
                    <div class="agpr-headerEditor-aiQuickTip-content">
                        <div
                            class="agpr-headerEditor-aiQuickTip-heading"
                            [innerHTML]="('Common.dialog.aiDistributionHeader.quickTip.heading' | localize) | sanitizeHtml"
                        ></div>
                        <div class="agpr-headerEditor-aiQuickTip-body">
                            <span class="agpr-headerEditor-aiQuickTip-body-icon fa-kit-duotone fa-agpr-ai"></span> {{ aiQuickTipInfo | localize }}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- footer -->
        <div class="agpr-headerEditor-bodyFooter">
            <agpr-action-bar>
                <ng-template #left>
                    <agpr-button
                        [id]="'agpr_headerEditor_cancel'"
                        label="Core.button.cancel"
                        [style]="buttonTypes.secondary"
                        (click)="closeDialog()"
                    ></agpr-button>
                </ng-template>
                <ng-template #right>
                    <agpr-button
                        [id]="'agpr_headerEditor_update'"
                        [label]="'update'"
                        [primary]="true"
                        [style]="buttonTypes.primary"
                        (click)="updateHeader()"
                    >
                    </agpr-button>
                </ng-template>
            </agpr-action-bar>
        </div>
    </div>
</agpr-take-over-panel>
